import React from 'react'
import {Box} from '@mui/material'

interface Props {
    children: React.ReactNode
}
const SearchPageActionArea: React.FC<Props> = props => <Box mt={'10px'}>{props.children}</Box>

SearchPageActionArea.displayName = 'SearchPageActionArea'
export default SearchPageActionArea
